import { all, spawn } from 'redux-saga/effects';

// Import all Redux Toolkit sagas
import authSaga from './auth/authSagas';
import uiSaga from './ui/uiSagas';
import messageSaga from './message/messageSagas';
import userSaga from './user/userSagas';
import streamChatSaga from './stream-chat/streamChatSagas';

function* rootSaga() {
  yield all([
    spawn(authSaga),
    spawn(uiSaga),
    spawn(messageSaga),
    spawn(userSaga),
    spawn(streamChatSaga)
  ]);
}

export default rootSaga;
